import { useBlocker } from "react-router-dom";

/**
 * Blocks navigation when `when` is true. Works with React Router v6.
 * NOTE: This blocks in-app navigation. For browser refresh/close, also use useBeforeUnload.
 */
export function useUnsavedChangesBlocker(options: {
  when: boolean;
  disableDirtyCheck?: boolean;
  ignoreSamePath?: boolean;
}) {
  const { when, disableDirtyCheck = false, ignoreSamePath = true } = options;

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (disableDirtyCheck) return false;
    if (ignoreSamePath && currentLocation?.pathname === nextLocation?.pathname) return false;
    return when;
  });

  const isActive = blocker.state === "blocked";

  const onConfirm = () => blocker.proceed?.();
  const onCancel = () => blocker.reset?.();

  return { blocker, isActive, onConfirm, onCancel };
}
